<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: $t('qrUserTransfer.title') }"
    hide-confirm
    max-width="500"
    @close="resetData"
  >
        <div v-if="isLoading" class="flex flex-center pa-5">
      <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="primary"/>
      </div>

    <v-card v-else :disabled="loading" flat>
      <v-stepper style="padding: 0" v-model="e1">
        <v-stepper-items>
          <v-stepper-content style="padding: 0" step="1">
            <v-card-text>
              <v-radio-group v-model="type" hide-details @change="typeChange">
                <v-radio
                  :label="$t('qrUserTransfer.radioLabels.userTransfer')"
                  value="userTransfer"
                />
                <v-radio
                  :label="$t('qrUserTransfer.radioLabels.givingAccess')"
                  value="givingAccess"
                />
              </v-radio-group>
            </v-card-text>

            <v-card-title>
              <div class="d-flex align-center w-100">
                <div class="flex-grow-1">
                  <vue-tel-input
                    v-model="userPhon"
                    :default-country="defaultCountry"
                    :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                    :placeholder="$t('qrUserTransfer.inputLabels.phone')"
                    class="rounded-lg phone-input"
                    @input="onPhoneInput"
                    @validate="onPhoneValidate"
                    @keydown.enter="handleEnterKey"
                  />
                  <div
                    v-if="!phoneValidated.valid && userPhon"
                    class="error--text text-caption mt-1"
                    style="text-align: start"
                  >
                    {{ $t("qrUserTransfer.messages.invalidPhone") }}
                  </div>
                </div>

                <!-- دکمه + فقط در givingAccess -->
                <span
                  v-if="type === 'givingAccess'"
                  class="ml-2 grey--text text--darken-1 d-flex align-center"
                  style="cursor: pointer; white-space: nowrap"
                  @click="phoneValidated.valid && addPhoneNumber()"
                >
                  <v-icon small>mdi-plus</v-icon>
                  {{ $t("qrUserTransfer.buttons.add") }}
                </span>
              </div>
            </v-card-title>
            <v-card-actions v-if="type == 'userTransfer'" class="justify-end">
              <v-btn
                :disabled="!phoneValidated?.valid"
                :loading="loading"
                class="btn-accept ma-0"
                @click="setPermissions"
              >
                <v-icon left>mdi-swap-horizontal</v-icon>
                {{
                  type == "userTransfer"
                    ? $t("qrUserTransfer.buttons.transfer")
                    : $t("qrUserTransfer.buttons.giveAccess")
                }}
              </v-btn>
            </v-card-actions>
            <v-card
              flat
              v-if="users_list && users_list.length > 0"
              class="ma-4 mt-8"
            >
              <v-card-subtitle>{{
                $t("qrUserTransfer.subtitles.accessList")
              }}</v-card-subtitle>
              <v-expansion-panels v-model="panel" class="px-3">
                <v-expansion-panel
                  class="mb-4 list-expansion"
                  v-for="(item, index) in users_list"
                  :key="index"
                  @click="editUser = item"
                >
                  <v-expansion-panel-header class="text-right" rounded="xl">
                    <div class="d-flex justify-space-between align-center">
                      <div class="d-flex row">
                        <v-icon class="me-2">mdi-account</v-icon>
                        <div
                          class="d-flex column align-center justify-start"
                          style="flex-direction: column"
                        >
                          <span>{{ item.name }}</span>
                          <span class="light py-2">{{ item.numberphone }}</span>
                        </div>
                      </div>
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="deletedAcces(item)"
                            icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>{{
                          $t("qrUserTransfer.tooltips.deleteAccess")
                        }}</span>
                      </v-tooltip>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="py-5">
                    <v-list>
                      <v-btn
                        class="btn-accept mt-2"
                        @click="editAcces(item)"
                        :loading="loading"
                      >
                        {{ $t("qrUserTransfer.buttons.saveChanges") }}
                        <v-icon small right>mdi-content-save</v-icon>
                      </v-btn>
                      <v-list-item v-for="(per, i) in permissionList" :key="i">
                        <v-checkbox
                          v-model="item.permissions[per.value]"
                          :label="per.text"
                          class="mt-0 ms-2"
                          dense
                          hide-details
                        ></v-checkbox>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-stepper-content>
          <v-stepper-content style="padding: 0" step="2">
            <v-card flat>
              <v-card-text>
                <div class="d-flex align-center w-100">
                  <div class="flex-grow-1">
                    <vue-tel-input
                      v-model="userPhon"
                      :default-country="defaultCountry"
                      :preferred-countries="[
                        'IR',
                        'IQ',
                        'US',
                        'CA',
                        'GB',
                        'AE',
                      ]"
                      :placeholder="$t('qrUserTransfer.inputLabels.phone')"
                      class="rounded-lg phone-input"
                      @input="onPhoneInput"
                      @validate="onPhoneValidate"
                      @keydown.enter="handleEnterKeyStep2"
                    />
                    <div
                      v-if="!phoneValidated.valid && userPhon"
                      class="error--text text-caption mt-1"
                      style="text-align: start"
                    >
                      {{ $t("qrUserTransfer.messages.invalidPhone") }}
                    </div>
                  </div>

                  <span
                    v-if="type === 'givingAccess'"
                    class="ml-2 grey--text text--darken-1 d-flex align-center"
                    style="cursor: pointer; white-space: nowrap"
                    @click="phoneValidated.valid && addPhoneNumber()"
                  >
                    <v-icon small>mdi-plus</v-icon>
                    {{ $t("qrUserTransfer.buttons.add") }}
                  </span>
                </div>

                <v-card flat class="d-flex flex-wrap">
                  <number-trans
                    v-for="(phon, i) in userPhons"
                    :key="i"
                    :obj="phon"
                    v-model="phon.number"
                    @delete="userPhons.splice(i, 1)"
                    :checkInput="checkInput"
                  />
                </v-card>
              </v-card-text>

              <v-expand-transition>
                <div v-if="type === 'givingAccess'">
                  <v-card-subtitle class="mt-4 pb-1 ps-2">
                    {{ $t("qrUserTransfer.subtitles.selectPermissions") }}
                  </v-card-subtitle>
                  <v-checkbox
                    v-for="(item, i) in permissionList"
                    :key="i"
                    v-model="permissions"
                    :label="item.text"
                    :value="item.value"
                    class="mt-0 ms-2"
                    dense
                    hide-details
                  />
                </div>
              </v-expand-transition>

              <v-card-actions class="justify-content-between">
                <v-btn
                  v-if="type == 'givingAccess'"
                  color="red"
                  :loading="loading"
                  outlined
                  @click="e1 = 1"
                >
                  <v-icon left>mdi-chevron-right</v-icon>
                  {{ $t("qrUserTransfer.buttons.back") }}
                </v-btn>
                <v-btn
                  v-if="type == 'givingAccess'"
                  :disabled="userPhons.length === 0 || permissions.length == 0"
                  :loading="loading"
                  class="btn-accept ma-0"
                  @click="setPermissions"
                >
                  <v-icon left>mdi-swap-horizontal</v-icon>
                  {{ $t("qrUserTransfer.buttons.giveAccess") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </custom-popup>
</template>

<script>
import NumberTrans from "./NumberTrans.vue";
import {AtomSpinner} from 'epic-spinners'


export default {
  name: "qrUserTransfer",
  components: { NumberTrans,AtomSpinner },

  props: {
    value: Boolean,
    address: String,
  },

  data: () => ({
    info:{},
    originalPermissions: null,
    panel: null,
    editingUserIndex: null,
    users_list: [],
    userPhon: "",
    userPhons: [],
    phoneValidated: { valid: false, number: "", country: null },
    permissions: [],
    permission_id: null,
    type: "userTransfer",
    loading: false,
    e1: 1,
    editUser: {},
    isLoading: false, 
  }),

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    canSave() {
      return (
        (this.permissions.length > 0 ||
          this.type === "userTransfer" ||
          this.userPhons.length > 0) &&
        (this.type === "userTransfer" || this.phoneValidated?.valid)
      );
    },
    allPermissions() {
      return this.users_list.map((user) => ({
        phone: this.cleanPhone(user.numberphone),
        permissions: Object.fromEntries(
          Object.entries(user.permissions).map(([k, v]) => [k, !!v])
        ),
      }));
    },
    defaultCountry() {
      switch (this.$i18n.locale) {
        case "fa":
          return "IR";
        case "ar":
          return "IQ";
        case "en":
          return "US";
        default:
          return "IR";
      }
    },
    permissionList() {
      if (!this.info || !this.info.type) return [];

      const type = this.info?.type?.toLowerCase();
      const basePermissions = [
        {
          value: "edit_name",
          text: this.$t("qrUserTransfer.permissionList.edit_name"),
          promis: true,
        },
        {
          value: "edit_link",
          text: this.$t("qrUserTransfer.permissionList.edit_link"),
          promis: true,
        },
        {
          value: "edit_info",
          text: this.$t("qrUserTransfer.permissionList.edit_info"),
          promis: true,
        },
        {
          value: "edit_design",
          text: this.$t("qrUserTransfer.permissionList.edit_design"),
          promis: true,
        },
        {
          value: "edit_settings",
          text: this.$t("qrUserTransfer.permissionList.edit_settings"),
          promis: true,
        },
        {
          value: "toggle_access",
          text: this.$t("qrUserTransfer.permissionList.toggle_access"),
          promis: true,
        },
      ];

      if (["bshop", "appointment", "menu", "insurance"].includes(type)) {
        return [
          ...basePermissions,
          {
            value: "view_customers",
            text: this.$t("qrUserTransfer.permissionList.view_customers"),
            promis: false,
          },
          {
            value: "view_orders",
            text: this.$t("qrUserTransfer.permissionList.view_orders"),
            promis: false,
          },
        ];
      }
      return basePermissions;
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
 value(val) {
      if (val) {
        this.isLoading = true;
        this.fetchData()
          .then(() => {
            if (this.info && this.info?.id) {
              return this.getAccess(); 
            }
          })
          .finally(() => {
            this.isLoading = false; 
          });
      } else {
        this.resetData();
      }
    },   
     info: {
      deep: true,
      handler(val) {
        if (val) this.promis();
      },
    },
  },

  methods: {
   fetchData() {
      this.loading = true;
      console.log(this.address, "qrusertansfer");
      
      return this.$api
        .get(`/v1/testQr/find/${this.address}`)
        .then(({ data }) => {
          this.info = data.data;
        })
        .finally(() => (this.loading = false));
      },
     cleanPhone(phone) {
  if (!phone) return "";
  let cleaned = String(phone);
  
  const persianDigits = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
  const arabicDigits =  [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
  
  for (let i = 0; i < 10; i++) {
    cleaned = cleaned
      .replace(persianDigits[i], i)
      .replace(arabicDigits[i], i);
  }
  
  this.iran =
    cleaned.startsWith("+98") ||
    cleaned.startsWith("98") ||
    cleaned.startsWith("09");
    
  if (this.iran) {
    cleaned = cleaned.replace(/\s/g, "").replace(/\+/g, "");
    cleaned = cleaned.replace(/^0/, "98");
  } else {
    cleaned = cleaned.replace(/[^\d]/g, ""); // حذف تمام کاراکترهای غیر عددی (شامل + و فاصله)
  }
  
  return cleaned;
},
    onPhoneInput(number) {
       if (!number) {
    this.userPhon = "";
    return;
    }
      this.userPhon = number.replace(" ", "").replace("+", "") || "";
    },

    onPhoneValidate({ number, valid, country }) {
      if (
        number !== undefined &&
        valid !== undefined &&
        country !== undefined
      ) {
        this.phoneValidated = { number, valid, country };
        this.iran = country?.iso2 === "IR";
      }
    },
    addPhoneNumber() {
      if (!this.phoneValidated.valid) return;

      const cleaned = this.cleanPhone(this.phoneValidated.number);
      const exists = this.userPhons.some(
        (p) => this.cleanPhone(p.number) === cleaned
      );
      if (exists) {
        this.$toast.error(this.$t("qrUserTransfer.messages.duplicatePhone"));
        return;
      }
      console.log(this.phoneValidated.number,this.userPhons,"this.phoneValidated")
      this.userPhons.push({ number: this.phoneValidated.number });
      this.userPhon = "";
      this.phoneValidated = { valid: false, number: "", country: null };
      this.e1 = 2;
    },

    handleEnterKey() {
      if (this.type === "givingAccess" && this.phoneValidated.valid) {
        this.addPhoneNumber();
      }
    },

    // برای step 2
    handleEnterKeyStep2() {
      if (this.type === "givingAccess" && this.phoneValidated.valid) {
        if (this.checkInput(this.phoneValidated.number)) {
          this.userPhons.push({ number: this.phoneValidated.number });
          this.userPhon = "";
          this.phoneValidated = { valid: false };
        }
      }
    },

    checkInput(number) {
      const cleaned = this.cleanPhone(number);
      const find = this.userPhons.find(
        (item) => this.cleanPhone(item.number) === cleaned
      );
      if (find) {
        this.$toast.error(this.$t("qrUserTransfer.messages.duplicatePhone"));
        return false;
      }
      return true;
    },
    cancelEditing() {
      if (this.editingUserIndex !== null && this.originalPermissions) {
        this.$set(this.users_list[this.editingUserIndex], "permissions", {
          ...this.originalPermissions,
        });
      }
      this.editingUserIndex = null;
      this.originalPermissions = null;
      this.panel = null;
    },

    startEditing(index) {
      this.originalPermissions = { ...this.users_list[index].permissions };
      this.editingUserIndex = index;
      this.panel = index;
    },

    savePermissions(index) {
      this.loading = true;
      let number = this.userPhons?.map((item) => this.cleanPhone(item.number));

      const data = {
        permissions: Object.fromEntries(
          Object.entries(this.users_list[index].permissions).map(([k, v]) => [
            k,
            !!v,
          ])
        ),
        phones: number,
        qr_id: this.info.id,
        permission_id: this.users_list[index].id,
      };

      this.$api
        .post("/Qr/EditAccess", data)
        .then(({ data }) => {
          this.$toast.success(
            data.message ||
              this.$t("qrUserTransfer.messages.updateAccessSuccess")
          );
          this.editingUserIndex = null;
          this.panel = null;
          this.getAccess();
        })
        .catch(({ response }) => {
          this.$toast.error(
            this.$t("qrUserTransfer.messages.updateAccessError", {
              message: response?.data?.message || "نامشخص",
            })
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editAcces(item) {

      this.loading = true;
      let number = this.userPhons?.map((item) => this.cleanPhone(item.number));
      const data = {
        permissions: item.permissions,
        phones: number,
        qr_id: this.info.id,
        permission_id: item.id,
      };

      this.$api
        .post("/Qr/EditAccess", data)
        .then(({ data }) => {
          this.$toast.success(
            data.message ||
              this.$t("qrUserTransfer.messages.updateAccessSuccess")
          );
          this.editUser = {};
          this.panel = null;
          this.originalPermissions = null;
          this.getAccess();
        })
        .catch(({ response }) => {
          this.$toast.error(
            this.$t("qrUserTransfer.messages.updateAccessError", {
              message: response?.data?.message || "نامشخص",
            })
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async deletedAcces(item) {
      if (
        await this.$modal.yesNo(
          this.$t("qrUserTransfer.messages.confirmDeleteAccess")
        )
      ) {
        this.loading = true;
        const data = {
          qr_id: this.info.id,
          user_id: item.user_id,
        };
        this.$api
          .post("/Qr/deleteAccess", data)
          .then(({ data }) => {
            this.$toast.success(
              data.message ||
                this.$t("qrUserTransfer.messages.deleteAccessSuccess")
            );
            this.editUser = {};
            this.panel = null;
            this.originalPermissions = null;
            this.getAccess();
          })
          .catch(({ response }) => {
            this.$toast.error(
              this.$t("qrUserTransfer.messages.deleteAccessError", {
                message: response?.data?.message || "نامشخص",
              })
            );
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        return;
      }
    },

    getAccess() {
      this.loading = true;
      return this.$api 
        .get("/Qr/index-access", { params: { qr_id: this.info.id } })
        .then(({ data }) => this.processUsers(data?.users || []))
        .catch(({ response }) => {
          this.$toast.error(
            this.$t("qrUserTransfer.messages.fetchAccessError", {
              message: response?.data?.message || "نامشخص",
            })
          );
        })
        .finally(() => (this.loading = false));
    },

    processUsers(users) {
      if (!users.length) {
        this.users_list = [];
      } else {
        const firstUser = users[0];
        this.permission_id = firstUser?.id || null;

        const firstPermissions = {};
        this.permissions = Object.keys(firstPermissions).filter(
          (key) => firstPermissions[key]
        );

        this.users_list = users
          .filter((user) => Object.values(user.permissions || {}).includes(1))
          .map(({ phone, name, permissions, id, user_id }) => ({
            numberphone: this.cleanPhone(phone),
            name,
            permissions,
            id,
            user_id,
          }));

        this.type = "givingAccess";
      }
    },

    checkInput(number) {
      const find = this.userPhons.find((item) => item.number === number);
      if (find) {
        this.$toast.error(this.$t("qrUserTransfer.messages.duplicatePhone"));
        return false;
      }
      return true;
    },

    typeChange(type) {
      if (type === "userTransfer") {
        this.permissions = [];
      }
    },

    getSelectedPermissionsMap(selected) {
      return selected.reduce((obj, key) => {
        obj[key] = true;
        return obj;
      }, {});
    },

    setPermissions() {
      this.loading = true;

      if (this.type !== "givingAccess") {
        this.transferQr();
        return;
      }
      let number = this.userPhons?.map((item) => this.cleanPhone(item.number));

      const data = {
        permissions: this.getSelectedPermissionsMap(this.permissions),
        phones: number,
        qr_id: this.info.id,
        permission_id: null,
      };

      this.$api
        .post("/Qr/EditAccess", data)
        .then(({ data }) => {
          this.$toast.success(
            data.message || this.$t("qrUserTransfer.messages.giveAccessSuccess")
          );
          this.e1 = 1;
          this.userPhon = "";
          this.getAccess();
          this.resetData();
          this.permissions = [];
        })
        .catch(({ response }) => {
          this.permissions = [];
          this.$toast.error(
            this.$t("qrUserTransfer.messages.giveAccessError", {
              message: response?.data?.message || "نامشخص",
            })
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    transferQr() {
      const cleanphone_1 = this.cleanPhone(this.userPhon);
      this.$api
        .post("/Qr/transferOwner", {
          qr_id: this.info.id,
          phone: cleanphone_1,
        })
        .then(({ data }) => {
          this.$toast.success(
            data.message || this.$t("qrUserTransfer.messages.transferSuccess")
          );
          this.dialog = false;
          this.$emit("fetch");
          this.resetData();
        })
        .catch(({ response }) => {
          this.$toast.error(
            this.$t("qrUserTransfer.messages.transferError", {
              message: response?.data?.message || "نامشخص",
            })
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetData() {
      this.permissions = [];
      this.userPhon = "";
      this.userPhons = [];
      this.type = "userTransfer";
      this.info = null; 
      this.users_list = [];
      this.editingUserIndex = null;
      this.originalPermissions = null;
      this.panel = null;
    },

    promis() {
      // This method is now redundant as permissionList is handled in computed
      console.log(this.info?.type?.toLowerCase());
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
  color: black;
}
.light {
  color: gray;
  font-size: smaller;
}

.v-expansion-panel:not(.single)
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel:not(.single)
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .list-expansion >>> .v-expansion-panel-content__wrap {
    padding: 0 4px !important;
  }
}
.phone-input {
  direction: ltr !important;
}
.phone-input >>> .vti__dropdown {
  border-right: 1px solid #ccc;
  border-radius: 8px 0 0 8px;
}
.phone-input >>> .vti__input {
  border-radius: 0 8px 8px 0;
  height: 40px;
  font-size: 14px;
}
</style>
